// Live count on the Shop app listing; update deliberately.
export const REVIEW_COUNT = 245;
export const REVIEW_AVERAGE = "4.9";
